import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionItemFileCabinetFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		requisitionItemId?: any;
		fileCabinetId?: any;
}

export class RequisitionItemFileCabinetFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public requisitionItemId: IEntityModelField = { name: "requisitionItemId", displayName: "Requisition Item Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public fileCabinetId: IEntityModelField = { name: "fileCabinetId", displayName: "File Cabinet Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionItemId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionItemFileCabinetDTO implements IEntityModel {
	protected requisitionItemFileCabinetName: string = "RequisitionItemFileCabinetModel";
	protected requisitionItemFileCabinetKeyField: string = "id";
	protected requisitionItemFileCabinetDisplayName: string = "Requisition Item File Cabinet|Requisition Item File Cabinets";
	protected requisitionItemFileCabinetFields = new RequisitionItemFileCabinetFields();
	public get name(): string { return this.requisitionItemFileCabinetName };
	public get keyField(): string { return this.requisitionItemFileCabinetKeyField };
	public get displayName(): string { return this.requisitionItemFileCabinetDisplayName };
	public get fields(): RequisitionItemFileCabinetFields { return this.requisitionItemFileCabinetFields };

	constructor() {};
}
